/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SearchOperators } from './SearchOperators';
import {
    SearchOperatorsFromJSON,
    SearchOperatorsFromJSONTyped,
    SearchOperatorsToJSON,
} from './SearchOperators';

/**
 * 
 * @export
 * @interface SearchSupport
 */
export interface SearchSupport {
    /**
     * 
     * @type {SearchOperators}
     * @memberof SearchSupport
     */
    operators: SearchOperators;
}

/**
 * Check if a given object implements the SearchSupport interface.
 */
export function instanceOfSearchSupport(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "operators" in value;

    return isInstance;
}

export function SearchSupportFromJSON(json: any): SearchSupport {
    return SearchSupportFromJSONTyped(json, false);
}

export function SearchSupportFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSupport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'operators': SearchOperatorsFromJSON(json['operators']),
    };
}

export function SearchSupportToJSON(value?: SearchSupport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'operators': SearchOperatorsToJSON(value.operators),
    };
}

